// verantwortungVorbelegung.ts — FO und BO einer neuen Anlage aus dem
// angemeldeten Nutzer ableiten (PO 23.09.2026: „FO und BO vom Nutzer ableiten").
//
//   Frontoffice-Nutzer (Abteilung FO oder FO+BO) → er selbst als FO
//   Hat er ein Team                             → sein (erstes) Team als BO
//   Backoffice-Nutzer ohne Team                 → nichts; er wird NICHT FO
//   Abteilung unbekannt, kein Team              → er selbst als FO (Rückfall,
//                                                  damit der Kontakt nicht
//                                                  mandantenweit sichtbar wird)
//
// Admins sind nie FO (sie stehen auch nicht in der FO-Auswahl).

export type VerantwortungVorbelegung = {
  foUserId: string;
  boType: "TEAM" | "NONE";
  boTeamId: string;
};

const teile = (abteilung: string | null | undefined): string[] =>
  String(abteilung ?? "")
    .split("+")
    .map((t) => t.trim().toUpperCase())
    .filter(Boolean);

export function vorbelegungVerantwortung(nutzer: {
  userId: string;
  abteilung: string | null | undefined;
  istAdmin: boolean;
  teamId: string | null | undefined;
}): VerantwortungVorbelegung {
  const abteilung = teile(nutzer.abteilung);
  const teamId = String(nutzer.teamId ?? "");
  const istFo = !nutzer.istAdmin && abteilung.includes("FO");
  const abteilungBekannt = abteilung.length > 0;
  let foUserId = "";
  if (nutzer.userId && !nutzer.istAdmin) {
    if (istFo) foUserId = nutzer.userId;
    else if (!abteilungBekannt && !teamId) foUserId = nutzer.userId;
  }
  return teamId ? { foUserId, boType: "TEAM", boTeamId: teamId } : { foUserId, boType: "NONE", boTeamId: "" };
}
